import {Injectable} from "@angular/core";
import {apiconfig} from "../app/api.config";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "./AuthService";
import {Pcheck} from "../model/Pcheck";

@Injectable()
export class PcheckService {

  apiConfig: any = apiconfig;


  constructor(protected http: HttpClient, public authService: AuthService) {
  }

  /**
   * TODO: move to use a Locupa / MissionORder end point and not a native LOGA WUI
   * Get orders according to a criteria
   */
  public findPcheck(p_missionId: number): Promise<Pcheck[]> {
    let h = this.authService.getHttpAuth();
    return this.http.get<Pcheck[]>(this.apiConfig.API_URL + '/operational/presencecheck/mission/' + p_missionId, {headers: h}).toPromise()
  }

}



// WEBPACK FOOTER //
// ./src/services/PcheckService.ts